export const MedicalDept = {
  DENT: "DENT",
  DERM: "DERM",
  PS: "PS",
  OS: "OS",
  OPH: "OPH",
  KM: "KM",
  NS: "NS",
  CS: "CS",
  IM: "IM",
  COMMON: "COMMON",
  VET_COMMON: "VET_COMMON",
};

export const MedicalDeptText = {
  DENT: "치과",
  DERM: "피부과",
  PS: "성형외과",
  OS: "정형외과",
  OPH: "안과",
  KM: "한의원",
  NS: "신경외과",
  CS: "흉부외과",
  IM: "내과",
  COMMON: "공통",
  VET_COMMON: "수의과",
};

export function convertMedicalDept(value) {
  return MedicalDeptText[value] || "";
}

export const OphSurgeryPart = {
  LEFT: "좌안",
  RIGHT: "우안",
};

export const OphCompanies = {
  zeiss: {
    name: "ZEISS",
    imgUrl: "",
    colorCode: "#D8DCF3",
  },
};

export const YnEnum = {
  Y: "Y",
  N: "N",
};

export const GenderEnum = {
  MALE: "M",
  FEMALE: "F",
};

export const ProductTypeEnum = {
  IMPLANT: "임플란트",
  ABUTMENT: "보철",
  TRANSPARENTBRACE: "투명교정",
  ZIRCONIA: "지르코니아",
};

export const NftTitleEnum = {
  DENTIUM: "덴티움 정품 인증서",
  POINTIMPLANT: "포인트임플란트 정품 인증서",
  POINTIMPLANTUV: "포인트 UV 임플란트 인증서",
  WITHWELLIMPLANT: "위드웰임플란트 정품 인증서",
  PLASMAPP: "플라즈맵 정품 표면처리 인증서",
  ZEISS: "자이스 코리아", // 해야 됨
  PS_HOSPITAL: "수술 책임관리 인증서",
  PS_CERTIFIED: "정품 보형물 인증서",
  PS_NOTCERTIFIED: "보형물 시술 확인서",
  ETC: "임플란트 제품 확인서",
  DENT: {
    IMPLANT: {
      HIGHNESS: "하이니스 임플란트 정품 인증서",
      COWELLMEDI: "코웰메디 임플란트 정품 인증서",
      DENTIS: "덴티스 임플란트 정품 인증서",
    },
    ABUTMENT: {
      HIGHNESS: "디지털 보철 정품 인증서",
      COWELLMEDI: "SFIT 보철 정품 인증서",
      ETC: "보철 제품 확인서",
    },
    ZIRCONIA: {
      DENTALMAX: "보철 정품 인증서",
    },
  },
};

export const KlipCompanyNameEnum = {
  DENTIUM: "덴티움(Dentium)",
  POINTIMPLANT: "포인트임플란트(Point Implant)",
  WITHWELLIMPLANT: "위드웰임플란트(WithWell Implant)",
  PLASMAPP: "플라즈맵(Plasmapp)",
  ZEISS: "자이스 코리아",
  SUNMEDICAL: "썬메디칼(Sun Medical)",
  INNODTECH: "이노디테크(innoDtech)",
  HIGHNESS: "하이니스(Highness)",
  COWELLMEDI: "코웰메디(Cowellmedi)",
  DENTALMAX: "DENTALMAX",
  DENTIS: "덴티스(Dentis)",
};

export const InformTextEnum = {
  DEFAULT: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
  ZEISS: `위 수술 관련 데이터의 모든 소유권과 책임은 병원에 있으며, 문의사항은 해당병원으로 부탁 드립니다.`,
  ZEISS_OTHER: `문의사항은 해당 병원으로 부탁드립니다.`,
};

// 중국어 InformText
export const InformTextEnumZH = {
  DEFAULT: `上述手术相关数据的所有权及责任归医院所有，如有疑问请联系该医院`,
  ZEISS: `上述手术相关数据的所有权及责任归医院所有，如有疑问请联系该医院`,
  ZEISS_OTHER: `如有疑问请联系该医院`,
};

export const TraitTypeEnum = {
  COMMON: {
    DEPT: "진료 과목",
    PRODUCTTYPE: "수술/시술 구분",
    HOSPITALNAME: "병원명",
    SURGERYDATE: "시술일자",
    DOCTORNAME: "수술 의사",
    SURGERYAREA: "수술 부위",
    COMPANYNAME: "제조사",
    INFORMTEXT: "안내사항",
    ISSUEDBY: "발행주체",
    PRODUCTNAME: "제품명",
    SPEC: "제품 사양",
  },
  DENT: {
    TOOTHNO: "치아 번호",
    BRACEPART: "교정 부위",
  },
  OPH: {},
  PS: {
    IMPLANT_COMPANY: "보형물 제조사",
    IMPLANT_NAME: "보형물 제품명",
    IMPLANT_SPEC: "보형물 사양",
    IMPLANT_NO: "보형물 정품인증번호",
    LEFT_COMPANY: "보형물(L) 제조사",
    RIGHT_COMPANY: "보형물(R) 제조사",
    LEFT_NAME: "보형물(L) 제품명",
    RIGHT_NAME: "보형물(R) 제품명",
    LEFTSPEC: "보형물(L) 제품 사양",
    RIGHTSPEC: "보형물(R) 제품 사양",
    LEFTNO: "보형물(L) 정품인증번호",
    RIGHTNO: "보형물(R) 정품인증번호",
    NO: "보형물 정품인증번호",
  },
  VET_COMMON: {
    ANIMAL_NAME: "반려동물명",
    DOG_BREED: "견종",
    CAT_BREED: "묘종",
  },
};

export const IssuanceMethodEnum = {
  PRODUCT_BASED_ISSUANCE: "PRODUCT_BASED_ISSUANCE",
  TOOTH_BUNDLED_ISSUANCE: "TOOTH_BUNDLED_ISSUANCE",
  BUNDLED_ISSUANCE: "BUNDLED_ISSUANCE",
  MANUFACTURER_BASED_ISSUANCE: "MANUFACTURER_BASED_ISSUANCE",
  PROJECT_BASED_ISSUANCE: "PROJECT_BASED_ISSUANCE",
  SEOLBI_ALIMTALK_PUBLISH: "SEOLBI_ALIMTALK_PUBLISH",
  CLARA_ALIMTALK_REGULARLY: "CLARA_ALIMTALK_REGULARLY",
  ABUTMENT_ISSUANCE: "ABUTMENT_ISSUANCE",
  ZIRCONIA_ISSUANCE: "ZIRCONIA_ISSUANCE",
  VET_ALIMTALK_REGULARLY: "VET_ALIMTALK_REGULARLY",
};

export const WarrantyStatusEnum = {
  ISSUED: "issued",
  SEND_BIZ: "send-biz",
  SEND_LMS: "send-lms",
  BIZ_SEND_ERROR: "biz_send_error",
  RETURNED: "returned",
  DISPOSED: "disposed",
  WECHAT_ISSUED: "wechat-issued",
};

export const WarrantyStatusText = {
  ISSUED: "지갑 저장됨",
  SEND_BIZ: "카톡 전송됨",
  SEND_LMS: "문자 전송됨",
  BIZ_SEND_ERROR: "미수신",
  RETURNED: "회수됨",
  DISPOSED: "삭제됨",
};

export const WarrantyImgUrlEnum = {
  DISPOSED:
    "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2Fdisposed.png",
  RETURNED:
    "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%2Freturned.png",
};

export function convertWarrantyStatus(value) {
  return WarrantyStatusText[value] || "-";
}

export const TraitTypeEnumZH = {
  COMMON: {
    DEPT: "诊疗科目",
    PRODUCTTYPE: "手术 / 治疗类别",
    HOSPITALNAME: "医院名称",
    SURGERYDATE: "治疗日期",
    DOCTORNAME: "手术医生",
    SURGERYAREA: "手术部位",
    COMPANYNAME: "制造商",
    INFORMTEXT: "注意事项",
    ISSUEDBY: "注册人",
    PRODUCTNAME: "产品名称",
    SPEC: "产品规格",
  },
  DENT: {
    TOOTHNO: "牙齿编号",
    BRACEPART: "矫正部位",
  },
};

export const MedicalDeptTextZH = {
  DENT: "牙科",
  DERM: "皮肤科",
  PS: "整形外科",
  OS: "矫形外科",
  OPH: "眼科",
  KM: "韩医院",
  NS: "神经外科",
  CS: "胸外科",
  IM: "内科",
  COMMON: "通用",
  VET_COMMON: "兽医科",
};

export function convertMedicalDeptZH(value) {
  return MedicalDeptTextZH[value] || "";
}

export const ProductTypeEnumZH = {
  IMPLANT: "种植体",
  ABUTMENT: "义齿",
  TRANSPARENTBRACE: "隐形矫正",
  ZIRCONIA: "氧化锆",
};

export const TreatmentTypeNameZH = {
  CROWN: "牙冠（Crown）",
  IMPLANT_CROWN: "种植体牙冠（Implant Crown）",
  BRIDGE: "牙桥（Bridge）",
  INLAY: "嵌体（Inlay）",
  LAMINATE: "瓷贴面（Laminates）",
};

export const NftTitleEnumZH = {
  DENT: {
    ZIRCONIA: {
      DENTALMAX: "义齿正品认证书",
    },
  },
};

export const DentalMaxDescriptionZH =
  "本卡用于认证本机构通过正规渠道使用 Dentalmax 公司的氧化锆产品。";

export function getTraitTypeEnum(locale) {
  return locale === "zh" ? TraitTypeEnumZH : TraitTypeEnum;
}

export function getInformTextEnum(locale) {
  return locale === "zh" ? InformTextEnumZH : InformTextEnum;
}

export function getTreatmentTypeName(treatmentType, locale) {
  if (locale === "zh") {
    return TreatmentTypeNameZH[treatmentType] || "义齿";
  }
  const typeMap = {
    CROWN: "크라운",
    IMPLANT_CROWN: "임플란트 크라운",
    BRIDGE: "브릿지",
    INLAY: "인레이",
    LAMINATE: "라미네이트",
  };
  return typeMap[treatmentType] || "보철";
}

export const BuildModeEnum = {
  PROD: "production",
  STG: "stage",
  DEV: "development",
  LOCAL: "local",
};

export const ProductTypeStatusEnum = {
  DEFAULT: "DEFAULT",
  EMPTY: "EMPTY",
  NO_AUTHORITY: "NO_AUTHORITY",
};
